import type { FreeHotelItem, PremiumHotelItem } from 'hooks/useDirectoryData/types';

import c from './_mapCard.module.scss';

import i18n from 'i18n-react';

export interface MapCardProps {
  marker: { kind: 'premium'; hotel: PremiumHotelItem } | { kind: 'free'; hotel: FreeHotelItem };
  onViewProfile: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export function MapCard({ marker, onViewProfile, onMouseEnter, onMouseLeave }: MapCardProps) {
  if (marker.kind === 'premium') {
    const { hotel } = marker;
    return (
      <div className={c.card} onClick={onViewProfile} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <div className={c.body}>
          <span className={c.name}>{hotel.propertyName}</span>
          {hotel.sub_catname && <span className={c.category}>{hotel.sub_catname}</span>}
          <span className={c.cta}>{i18n.translate('directoryView.viewNow') as string}</span>
        </div>
      </div>
    );
  }

  const { hotel } = marker;
  const subtitle = hotel.cuisine ?? hotel.cat_name;

  return (
    <div className={c.card} onClick={onViewProfile} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className={c.body}>
        <span className={c.name}>{hotel.company}</span>
        {hotel.city && <span className={c.detail}>{hotel.city}</span>}
        {hotel.phone && <span className={c.detail}>{hotel.phone}</span>}
        {subtitle && <span className={c.detail}>{subtitle}</span>}
        <span className={c.cta}>{i18n.translate('directoryView.viewNow') as string}</span>
      </div>
    </div>
  );
}
